import React, { useEffect, useState, useRef, useContext } from "react";
import ItemSingleCard from "./ItemSingleCard";
import "../css/CommonStyle.css";
import "../css/ItemsInACarModel.css";

import Header from "./Header";
import axios from "axios";
import CartSidebar from "./CartSidebar";
import ic_dropdwon from "../img/ic_down_dropdown.png";

import normal_checkbox from "../img/ic_not_selected_round.png"
import selected_checkbox from "../img/ic_selected_round.png"

import "../css/SubCategory.css";

import { useNavigate, useSearchParams } from "react-router-dom";
import "../css/PartsList.css";
import ic_minus from "../img/ic_minus.png";
import ic_plus from "../img/ic_plus.png";
import { ShoppingCartContext } from "./ShoppingCartContext";
import "../css/ShowPartsList.css";
import ic_continue from "../img/ic_continue.png";
import ic_filter from "../img/ic_filter.png";
import "../css/CommonStyle.css";

import ic_no_image from "../img/ic_no_image_available_big.png";
import ic_zoom from "../img/ic_zoom.png";
import { useIntersectionObserver } from "../hooks/useIntersectionObserver";
import ic_zoomin from "../img/ic_zoomin.png";
import ic_zoomout from "../img/ic_zoomout.png";
import ic_zoom_reset from "../img/ic_reset_zoom.png";
import ic_close_popup from "../img/ic_close_popup.png";

function ShowPartsList() {

    const [userSearchedTextState, setUserSearchedTextState] = useState("");

    const [clickedItemToShowInPopup, setClickedItemToShowInPopup] = useState(null)

    const [showOptionPopup, setShowOptionPopup] = useState(false)



    const currentSelectedOption = useRef("")

    const [arrayOfPartType, setArrayOfPartType] = useState([
        {
            id: 1,
            name: "BODY PARTS",
            showed_this_in_title: false
        },
        {
            id: 2,
            name: "SUSPENSION PARTS",
            showed_this_in_title: false
        }
        ,
        {
            id: 3,
            name: "RUBBER PARTS",
            showed_this_in_title: false
        },
        {
            id: 4,
            name: "ENGINE PARTS",
            showed_this_in_title: false
        },
        {
            id: 5,
            name: "HYDRAULIC PARTS",
            showed_this_in_title: false
        },
        {
            id: 6,
            name: "ELECTRIC PARTS",
            showed_this_in_title: false
        }
    ])

    const originalImageValue = useRef(1);
    // State variable for managing zoomed image
    const [zoomedImage, setZoomedImage] = useState(null);
    // Function to open zoomed image
    const openZoomedImage = (imageUrl) => {
        setZoomedImage(imageUrl);
    };
    // Function to close zoomed image
    const closeZoomedImage = () => {
        setZoomedImage(null);
    };

    const imageToBeZoomedRef = useRef(null);

    const limit = 10;

    const [data, setData] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isInitialFetch, setIsInitialFetch] = useState(false);

    const pageRef = useRef(1);
    const [hasMore, setHasMore] = useState(false);

    const [currentItemAddedToCart, setCurrentItemAddedToCart] = useState(null)
    const [clickedImagelink, setClickedImageLink] = useState(null)
    const [screenGreaterThanTab, setScreenGreaterThanTab] = useState(false)
    const [filterPanelToggle, setFilterPanelToggle] = useState(false)
    const [makeArrayFromLocalStorage, setMakeArrayFromLocalStorage] = useState(null)
    const [modelArrayAfterSelectingModel, setModelArrayAfterSelectingModel] = useState(null)
    const [mainAndSubCategory, setMainAndSubCategory] = useState(null)

    const [searchParams, setSearchParams] = useSearchParams();

    //let makename = searchParams.get('makename');
    // let modelname = searchParams.get('modelname');
    //let maincategory = searchParams.get('maincategory');
    //let subcategory = searchParams.get('subcategory');

    const [makename, setMakename] = useState(searchParams.get('makename'))
    const [modelname, setModelname] = useState(searchParams.get('modelname'))

    const [maincategory, setMaincategory] = useState(searchParams.get('maincategory'))
    const [subcategory, setSubcategory] = useState(searchParams.get('subcategory'))
    const [subSearchKey, setSearchkey] = useState(searchParams.get('searchkey'))


    // console.log("makeName ", makename);
    // console.log("modelname ", modelname);
    // console.log("maincategory ", maincategory);
    // console.log("subcategory ", subcategory);

    const getModelsOfThisMake = (makename) => {

        axios.get(`https://cubixweberp.com:197/api/InventMasters/InventoryLevel2?cmpcode=AUTOLAND&guid=C406671E-B36F-4D24-B0D2-04D129936FBE&mod=LEVEL2&lvl1=${makename}`).then((res) => {

            let mappedModelArray = res.data?.map((itemOfModel) => {
                if (itemOfModel.Model == modelname) {
                    return { ...itemOfModel, is_selected: true }
                } else {
                    return { ...itemOfModel, is_selected: false }
                }
            })

            setModelArrayAfterSelectingModel(mappedModelArray)

        }).catch((err) => {
            console.log("err ", err)
        })
    }

    useEffect(() => {

        getModelsOfThisMake(makename)

        const getMakeArrayFromLocalStorage = localStorage.getItem("autoland_make_array");

        if (getMakeArrayFromLocalStorage != null) {

            let newArrayWithSelectedModel = JSON.parse(getMakeArrayFromLocalStorage).map((itemOfMake) => {
                if (itemOfMake.Make == makename) {
                    return { ...itemOfMake, is_selected: true }
                } else {
                    return { ...itemOfMake, is_selected: false }
                }

            });

            setMakeArrayFromLocalStorage(newArrayWithSelectedModel)
        }

    }, [])

    useEffect(() => {

        if (makename) {
            getModelsOfThisMake(makename)
        }


    }, [makename])

    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext)

    const [showCartSidebar, setShowCartSidebar] = useState(false)
    const navigate = useNavigate();

    const [arrayOfBrands, setArrayOfBrands] = useState(null)

    const [isCallingBrandAPI, setIsCallingBrandAPI] = useState(false)


    let pathArray = [{ name: "make", path: "" }, { name: "model", path: "model" },
    { name: "group", path: "group" }]

    const [itemList, setItemList] = useState(null)
    const [isCallingApi, setIsCallingAPI] = useState(false)

    const getItemsFromAPI = () => {

        setIsCallingAPI(true)

        let subcategoryUrl = `https://cubixweberp.com:197/api/InventMasters/InventoryList?cmpcode=AUTOLAND&guid=F285D054-3200-4413-A624-DAD26D8A5616&mod=SEARCH_ITEMS&lvl1=ALL&lvl2=${makename}&lvl3=${modelname}&lvl4=ALL&lvl5=${subcategory}&searchKey=${subSearchKey ? subSearchKey : "all"}`

        axios.get(subcategoryUrl).then((res) => {

            setTimeout(() => {
                setIsCallingAPI(false)

                let newArray = res.data.map((item) => {
                    return { ...item, checked_status: false, quantity_in_shopping_cart: 1 }
                })
                console.log("newarray axios call ", newArray)

                // filter Type Wise First

                //then put to setItemList

                const result = Object.groupBy(newArray, ({ Group2 }) => Group2);
                console.log("result after grouping ", result)

                let spreadedResult = [];

                const newOrderPartType = arrayOfPartType.map((itemCorrectOrderPartType) => {

                    let getThisCategory = itemCorrectOrderPartType.name.trim();

                    console.log(`result[getThisCategory] ${getThisCategory}  `, result[getThisCategory])
                    console.log("itemCorrectOrderPartType.name pppp ", getThisCategory)

                    if (result[getThisCategory]) {

                        result[getThisCategory][0]["isThisTitle"] = getThisCategory

                        spreadedResult = [...spreadedResult, ...result[getThisCategory]]
                    }

                    // if (spreadedResult.length == 0) {
                    //     spreadedResult = [...(result[getThisCategory])]
                    // } else {
                    //    spreadedResult = [...spreadedResult, ...(result[getThisCategory])]
                    // }
                })

                // for (const [key, value] of Object.entries(result)) {
                //     console.log(`${key}: ${value}`);
                //     if(spreadedResult.length == 0){
                //         spreadedResult = [...value]
                //     }else{
                //         spreadedResult = [...spreadedResult, ...value]
                //     }

                // }

                console.log("spreadedResult ", spreadedResult)

                setItemList(spreadedResult)

                //setItemList(newArray)

            }, 1000)


        }).catch((err) => {
            setIsCallingAPI(false)
            console.log("err is ", err)
        })
    }




    const getItemsFromAPIAfterModelSelected = (modelFromClick) => {

        setIsCallingAPI(true)

        let subcategoryUrl = `https://cubixweberp.com:197/api/InventMasters/InventoryList?cmpcode=AUTOLAND&guid=F285D054-3200-4413-A624-DAD26D8A5616&mod=SEARCH_ITEMS&lvl1=ALL&lvl2=${makename}&lvl3=${modelFromClick}&lvl4=ALL&lvl5=${subcategory}&searchKey=${subSearchKey ? subSearchKey : "all"}`

        axios.get(subcategoryUrl).then((res) => {

            setTimeout(() => {

                setIsCallingAPI(false)

                let newArray = res.data.map((item) => {
                    return { ...item, checked_status: false, quantity_in_shopping_cart: 1 }
                })

                console.log("newarray axios call ", newArray)

                if (newArray?.length == 0) {
                    setItemList(null)
                } else {


                    // filter Type Wise First

                    //then put to setItemList

                    const result = Object.groupBy(newArray, ({ Group2 }) => Group2);
                    console.log("result after grouping ", result)

                    let spreadedResult = [];

                    const newOrderPartType = arrayOfPartType.map((itemCorrectOrderPartType) => {

                        let getThisCategory = itemCorrectOrderPartType.name.trim();

                        console.log(`result[getThisCategory] ${getThisCategory}  `, result[getThisCategory])
                        console.log("itemCorrectOrderPartType.name pppp ", getThisCategory)

                        if (result[getThisCategory]) {

                            result[getThisCategory][0]["isThisTitle"] = getThisCategory

                            spreadedResult = [...spreadedResult, ...result[getThisCategory]]
                        }

                        // if (spreadedResult.length == 0) {
                        //     spreadedResult = [...(result[getThisCategory])]
                        // } else {
                        //    spreadedResult = [...spreadedResult, ...(result[getThisCategory])]
                        // }
                    })

                    // for (const [key, value] of Object.entries(result)) {
                    //     console.log(`${key}: ${value}`);
                    //     if(spreadedResult.length == 0){
                    //         spreadedResult = [...value]
                    //     }else{
                    //         spreadedResult = [...spreadedResult, ...value]
                    //     }

                    // }

                    console.log("spreadedResult ", spreadedResult)

                    setItemList(spreadedResult)

                    //setItemList(newArray)
                }

            }, 1000)


        }).catch((err) => {
            setIsCallingAPI(false)
            console.log("err is ", err)
        })
    }

    const clickedOnMake = (makenameFromClick) => {

        console.log("make>>>>", makenameFromClick)

        setMakename(makenameFromClick);

        let newaaray = makeArrayFromLocalStorage.map((item) => {
            if (makenameFromClick == item.Make) {
                return { ...item, is_selected: true }
            } else {
                return { ...item, is_selected: false }
            }

        })
        setMakeArrayFromLocalStorage(newaaray)
    }

    const clickedOnModel = (modelnameFromClick) => {

        console.log("model>>>>", modelnameFromClick)

        setModelname(modelnameFromClick)

        getItemsFromAPIAfterModelSelected(modelnameFromClick)

        // console.log("makeArrayFromLocalStorage modelnameFromClick ", makeArrayFromLocalStorage, modelnameFromClick)

        let newaaray = modelArrayAfterSelectingModel?.map((item) => {
            if (modelnameFromClick == item.Model) {
                return { ...item, is_selected: true }
            } else {
                return { ...item, is_selected: false }
            }

        })
        setModelArrayAfterSelectingModel(newaaray)
    }





    const clickedOnMakeModelContinue = () => {
        navigate("/cart")
    }


    const checkIfItemAlreadyPresentInCart = (itemFromParent) => {


        let localStorageItems = localStorage.getItem("autoland_ordered_items");

        let arrayOfItems = []

        if (localStorageItems != null) {
            arrayOfItems = JSON.parse(localStorageItems)
        }

        return arrayOfItems.some((itemInArray) => {
            return itemInArray.Code == itemFromParent.Code
        })
    }

    const clickedOnShoppingCart = (itemFromClick) => {

        let localStorageItems = localStorage.getItem("autoland_ordered_items");

        let arrayOfItems = []

        if (localStorageItems != null) {
            arrayOfItems = JSON.parse(localStorageItems)
        }

        console.log("current context is arrayOfItems ", arrayOfItems, itemFromClick)

        if (itemFromClick.quantity_in_shopping_cart == "" || itemFromClick.quantity_in_shopping_cart == 0) {
            alert("please enter quantity")
            return
        }

        let updatedItemWithQuantity = { ...itemFromClick }

        if (arrayOfItems.length != 0) {

            if (checkIfItemAlreadyPresentInCart(itemFromClick)) {

                const updatedArrayWithQuantityIncremented = arrayOfItems.map((itemInArray) => {
                    if (itemInArray.Code == itemFromClick.Code) {
                        return { ...itemInArray, quantity_in_shopping_cart: itemInArray.quantity_in_shopping_cart + itemFromClick.quantity_in_shopping_cart }
                    } else {
                        return itemInArray
                    }
                })

                setShoppingCart(updatedArrayWithQuantityIncremented)

                // saving to localstorage
                localStorage.setItem("autoland_ordered_items", JSON.stringify(updatedArrayWithQuantityIncremented))

            } else {
                setShoppingCart([...arrayOfItems, updatedItemWithQuantity])

                // saving to localstorage
                localStorage.setItem("autoland_ordered_items", JSON.stringify([...arrayOfItems, updatedItemWithQuantity]))
            }


        } else {
            setShoppingCart([updatedItemWithQuantity])
            // saving to localstorage
            localStorage.setItem("autoland_ordered_items", JSON.stringify([updatedItemWithQuantity]))
        }



        // now show sidebar optimise it to show after items updated is confirmed

        setShowCartSidebar(true)
    }



    const getMainAndSubCategory = () => {

        let mainAndSubCategoryLoclaStorage = localStorage.getItem("autoland_group_and_subgroup")
        let parsedArray = []
        if (mainAndSubCategoryLoclaStorage != null) {

            parsedArray = JSON.parse(mainAndSubCategoryLoclaStorage).map((itemOfParse) => {

                if (itemOfParse.label == maincategory) {

                    let optionsFiltered = itemOfParse?.options?.map((itemOfOption) => {

                        if (itemOfOption.group == subcategory) {
                            return { ...itemOfOption, is_selected: true }
                        } else {
                            return { ...itemOfOption, is_selected: false }
                        }
                    })

                    return { ...itemOfParse, is_selected: true, options: optionsFiltered }

                } else {
                    return { ...itemOfParse, is_selected: false }
                }

            })

        }
        setMainAndSubCategory(parsedArray)

    }

    const showHideFIlterPanel = () => {
        setFilterPanelToggle(prev => !prev)
    }

    useEffect(() => {

        const screenGreaterThanTab = window.matchMedia("(min-width: 576px)").matches
        setFilterPanelToggle(screenGreaterThanTab)

        getItemsFromAPI()

        getMainAndSubCategory()

    }, [])

    const clickdeOnPartIcon = (imageLink, itemClicked) => {

        setClickedImageLink(imageLink)

        setClickedItemToShowInPopup(itemClicked)
    }

    const clickedOnApply = () => {

        // needed because if we scroll below and shows loading then pageRef will be 2 more
        pageRef.current = 1;

        // needed because even if api returns empty array , previous values are there it will be shown
        setItemList(null)

        // needed because else list will e present there from data state variable
        setData(null)


        setHasMore(false)

        getItemsFromAPI()
    }

    const clickedOnCategory = (clickedCategory) => {

        setMaincategory(clickedCategory)

        let mainAndSubCategoryLoclaStorage = localStorage.getItem("autoland_group_and_subgroup")
        let parsedArray = []
        if (mainAndSubCategoryLoclaStorage != null) {

            parsedArray = JSON.parse(mainAndSubCategoryLoclaStorage).map((itemOfParse) => {

                if (itemOfParse.label == clickedCategory) {

                    let optionsFiltered = itemOfParse?.options?.map((itemOfOption, index) => {

                        if (index == 0) {
                            return { ...itemOfOption, is_selected: true }
                        } else {
                            return { ...itemOfOption, is_selected: false }
                        }
                    })

                    return { ...itemOfParse, is_selected: true, options: optionsFiltered }

                } else {
                    return { ...itemOfParse, is_selected: false }
                }

            })

        }
        setMainAndSubCategory(parsedArray)

    }

    const clickedOnSubCategory = (clickedSubCategory) => {

        setSubcategory(clickedSubCategory)

        let parsedArray = mainAndSubCategory.map((itemOfParse) => {

            if (itemOfParse.is_selected) {

                let optionsFiltered = itemOfParse?.options?.map((itemOfOption) => {

                    if (itemOfOption.group == clickedSubCategory) {
                        return { ...itemOfOption, is_selected: true }
                    } else {
                        return { ...itemOfOption, is_selected: false }
                    }
                })

                return { ...itemOfParse, is_selected: true, options: optionsFiltered }

            } else {
                return { ...itemOfParse, is_selected: false }
            }

        })


        // console.log("parsedArray on clicking subcategory ", parsedArray)

        setMainAndSubCategory(parsedArray)

    }


    const clickedOnInputQuantityChanger = (inputType, currentValue, value, itemCode) => {

        if ("decrement" == inputType) {
            if (currentValue == 1) {
                console.log(" current value 1")
                return
            }
        }


        if (inputType == "input") {

            if (value) {


                console.log(`inputType >${inputType} value >${value?.target?.value} itemCode >${itemCode}`)
                //console.log("inputType value ", inputType, value.target.value, itemCode)

                let newArray = itemList?.map((itemForFIltering) => {

                    if (itemForFIltering.Code == itemCode) {
                        if (value.target.value == "") {

                            return { ...itemForFIltering, quantity_in_shopping_cart: "" }

                        } else {
                            return { ...itemForFIltering, quantity_in_shopping_cart: Number(value.target.value) }
                        }

                    } else {
                        return itemForFIltering
                    }
                })

                console.log(" newArray>>>>>> ", newArray)

                setItemList(newArray)

                if (clickedItemToShowInPopup != null) {
                    setClickedItemToShowInPopup(prev => ({ ...prev, quantity_in_shopping_cart: Number(value.target.value) }))
                }

            } else {
                console.log("value is empty", value)
            }


        } else {

            console.log(`inputType ${inputType} value ${value} itemCode ${itemCode}`)

            let newArray = itemList?.map((itemForFIltering) => {

                if (itemForFIltering.quantity_in_shopping_cart + value == 0) {
                    return itemForFIltering
                } else {
                    if (itemForFIltering.Code == itemCode) {
                        return { ...itemForFIltering, quantity_in_shopping_cart: itemForFIltering.quantity_in_shopping_cart + value }
                    } else {
                        return itemForFIltering
                    }
                }

            })

            // console.log(" newArray ", newArray)

            setItemList(newArray)
            if (clickedItemToShowInPopup != null) {
                setClickedItemToShowInPopup(prev => ({ ...prev, quantity_in_shopping_cart: prev.quantity_in_shopping_cart + value }))
            }

        }


    }

    const [targetRef, isIntersecting] = useIntersectionObserver({ threshold: 1 });

    useEffect(() => {
        if (hasMore && isIntersecting) {
            pageRef.current = pageRef.current + 1;

            // get next set of items
            console.log("get next set of items")
            //fetchPosts({ page: pageRef.current });
            getItemListFromAPIData(pageRef.current)
        }
    }, [isIntersecting, hasMore]);

    const getItemListFromAPIData = (page, isFetchingFirstTime) => {

        try {
            setIsError(false);
            isFetchingFirstTime && setIsInitialFetch(true);

            let endIndex;

            if ((itemList.length - (page * limit)) < limit) {

                endIndex = itemList.length // not subtracting 1 becuase slice wont item at endIndex
                console.log("now remaining items less than 10 ", (itemList.length - (page * limit)))
            }
            else {
                endIndex = page * limit;
                console.log("now remaining items greater  than 10 >>>> ", (itemList.length - (page * limit)))
            }

            const resPro = itemList.slice(((page - 1) * limit), endIndex);

            console.log("limit and page itemList length ", limit, page, itemList.length, endIndex)
            console.log("resPro ", resPro)

            const data = resPro;

            if (data) {
                setData((prev) => {

                    console.log("prev is ", prev)

                    let newData = [];

                    console.log("isFetchingFirstTime ", isFetchingFirstTime)
                    if (isFetchingFirstTime) {
                        newData = [...data];
                    } else {
                        newData = [...prev, ...data];
                    }


                    console.log("newData +++++++= ", newData)



                    if (newData.length < itemList.length) {
                        setHasMore(true);
                    } else setHasMore(false);

                    return newData;
                });
            } else {
                setHasMore(false);
            }

        } catch (err) {
            setHasMore(false);
            setIsError(true);
        } finally {
            setIsInitialFetch(false);
        }
    };

    useEffect(() => {

        if (itemList != null) {
            if (itemList.length > 0) {

                console.log(" getItemListFromAPIData(pageRef.current,true) called pageRef.current is and itemlist size  ", pageRef.current, itemList.length)
                getItemListFromAPIData(pageRef.current, true)
            }
        }
    }, [itemList])

    const zoomInTheImage = (scaleValue) => {

        originalImageValue.current = originalImageValue.current + scaleValue;

        if (imageToBeZoomedRef.current) {

            imageToBeZoomedRef.current.style.transform = `scale(${originalImageValue.current})`;
            imageToBeZoomedRef.current.style.transformOrigin = '0 0';
            console.log("zoomin")

        }
    }
    const zoomOutTheImage = (scaleValue) => {

        if ((originalImageValue.current - scaleValue) >= 1) {

            originalImageValue.current = originalImageValue.current - scaleValue;

            if (imageToBeZoomedRef.current) {

                imageToBeZoomedRef.current.style.transform = `scale(${originalImageValue.current})`;
                console.log("zoomin")

            }

        }

    }
    const resetTheImage = (e) => {

        originalImageValue.current = 1;

        if (imageToBeZoomedRef.current) {

            imageToBeZoomedRef.current.style.transform = `scale(${originalImageValue.current})`;
            console.log("reset")

        }
    }

    const clickedOnSelectOptionPopup = (currentOptionName) => {
        setShowOptionPopup(prev => !prev)

        currentSelectedOption.current = currentOptionName
    }

    const getArrayOfOption = (optionName, userSearchedText, fieldToBeSearched) => {

        console.log("mainAndSubCategory field userSearchedText ", modelArrayAfterSelectingModel, fieldToBeSearched, userSearchedText);

        if (userSearchedText == "") {

            console.log("inside if ")

            switch (optionName) {
                case "make": return makeArrayFromLocalStorage
                case "model": return modelArrayAfterSelectingModel
                case "category": return mainAndSubCategory
                case "subcategory": return mainAndSubCategory.filter((itemOfFilter) => itemOfFilter.is_selected)[0]?.options
            }
        } else {

            console.log("inside else optionName model",
                optionName, modelArrayAfterSelectingModel?.filter((itemFilter) => (itemFilter["Model"])?.toUpperCase().includes(userSearchedText?.toUpperCase()))
            )

            switch (optionName) {
                case "make": return makeArrayFromLocalStorage?.filter((itemFilter) => (itemFilter[fieldToBeSearched])?.toUpperCase().includes(userSearchedText?.toUpperCase()))
                case "model": return modelArrayAfterSelectingModel?.filter((itemFilter) => (itemFilter[fieldToBeSearched])?.toUpperCase().includes(userSearchedText?.toUpperCase()))
                case "category": return mainAndSubCategory
                case "subcategory": return mainAndSubCategory.filter((itemOfFilter) => itemOfFilter.is_selected)[0]?.options
            }
        }


    }
    const getKeyOfOption = (optionName) => {
        switch (optionName) {
            case "make": return "Make"
            case "model": return "Model"
            case "category": return "label"
            case "subcategory": return "group"
        }
    }

    const callMethod = (methodName, value) => {



        switch (methodName) {
            case "make": clickedOnMake(value);
                break;
            case "model": clickedOnModel(value);
                break;
            case "category": clickedOnCategory(value);
                break;
            case "subcategory": clickedOnSubCategory(value);
                break;
        }

    }

    const preventMouseWheelHappening = (e) => {
        console.log("do nothing on mouse wheel ")
        e.preventDefault();

    }


    const scrollMouseWheelHappening = (e) => {
        console.log("do nothing on scroll ")

    }

    const handleListSearchInput = (e) => {
        setUserSearchedTextState(e.target.value)
    }

    return (

        <div className="ItemsInACarModel-root-container common_page_bg">

            <div className="Header-wrapper">
                <Header />
            </div>

            {

                isCallingApi ?
                    <div className="ItemsInACarModel-Loading container d-flex flex-column justify-content-center align-items-center p-4">

                        <span>Please wait...</span>
                        <div className="spinner-border mt-4" role="status">

                        </div>

                    </div>
                    :


                    <div>


                        <div className="d-flex justify-content-end filter-button-mobile-panel">
                            <span className="filter-pill" onClick={() => showHideFIlterPanel()}>
                                <span>Filter</span>
                                <img className="filter-icon" src={ic_filter} />
                            </span>
                        </div>


                        <div className="ShowPartsList-main-content">

                            {
                                filterPanelToggle &&

                                <div className="ShowPartsList-side-filter pb-4">

                                    {/* for small devices , hide filter after clicking on apply*/}
                                    <div className="d-block d-sm-none">
                                        <h4 className="Filter-panel-head-mobile">Filter
                                            <span>
                                                <button className="filter-apply-button" onClick={() => { clickedOnApply(); showHideFIlterPanel() }}>Apply</button>
                                                <button className="filter-close-button ms-2" onClick={() => { showHideFIlterPanel() }}>Close</button>
                                            </span>
                                        </h4>
                                    </div>

                                    {/* for large devices, no need to hide after clicking on apply*/}
                                    <div className="d-none d-sm-block" >
                                        <h4 className="Filter-panel-head">Filter <button className="filter-apply-button" onClick={() => clickedOnApply()}>Apply</button></h4>
                                    </div>


                                    <div className="container-having-filter-boxes">

                                        <div className="filter-box-type first-filterbox">
                                            <h6 className="filter_box_heading">Make</h6>

                                            <div className="ShowPartsList-container-for-brand ">

                                                {
                                                    makeArrayFromLocalStorage != null ?
                                                        makeArrayFromLocalStorage.filter((item) => item.is_selected)?.map((item, index) => {
                                                            return (
                                                                <div className="PartsInACarModel-full-container-for-brand-element" onClick={() => clickedOnMake(item.Make)} key={index}>
                                                                    <img className="PartsInACarModel-full-container-for-brand-checkbox me-1" src={item.is_selected ? selected_checkbox : normal_checkbox} />
                                                                    <label className="PartsInACarModel-full-container-for-brand-name">{item.Make}</label>
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        null
                                                }
                                            </div>

                                            <button className="m-2 d-block btn btn-secondary btn-sm ms-auto" onClick={() => clickedOnSelectOptionPopup("make")}>select</button>

                                        </div>

                                        <div className="filter-box-type">
                                            <h6 className="filter_box_heading">Model</h6>
                                            <div className="ShowPartsList-container-for-brand ">

                                                {
                                                    modelArrayAfterSelectingModel != null ?

                                                        modelArrayAfterSelectingModel.length == 0 ?
                                                            <div className="m-2">
                                                                No model to show
                                                            </div>
                                                            :
                                                            modelArrayAfterSelectingModel.filter((item) => item.is_selected).map((item, index) => {
                                                                return (
                                                                    <div className="PartsInACarModel-full-container-for-brand-element" onClick={() => clickedOnModel(item.Model)} key={index}>
                                                                        <img className="PartsInACarModel-full-container-for-brand-checkbox me-1" src={item.is_selected ? selected_checkbox : normal_checkbox} />
                                                                        <label className="PartsInACarModel-full-container-for-brand-name">{item.Model}</label>
                                                                    </div>
                                                                )
                                                            })
                                                        :
                                                        null
                                                }
                                            </div>
                                            <button className="m-2 d-block btn btn-secondary btn-sm ms-auto" onClick={() => clickedOnSelectOptionPopup("model")}>select</button>

                                        </div>

                                        <div className="filter-box-type">
                                            <h6 className="filter_box_heading">Category</h6>
                                            <div className="ShowPartsList-container-for-brand ">

                                                {
                                                    mainAndSubCategory != null ?
                                                        mainAndSubCategory.filter((item) => item.is_selected).map((item, index) => {
                                                            return (
                                                                <div className="PartsInACarModel-full-container-for-brand-element" onClick={() => clickedOnCategory(item.label)} key={index}>
                                                                    <img className="PartsInACarModel-full-container-for-brand-checkbox me-1" src={item.is_selected ? selected_checkbox : normal_checkbox} />
                                                                    <label className="PartsInACarModel-full-container-for-brand-name">{item.label}</label>
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        null
                                                }
                                            </div>

                                            <button className="m-2 d-block btn btn-secondary btn-sm ms-auto" onClick={() => clickedOnSelectOptionPopup("category")}>select</button>
                                        </div>

                                        <div className="filter-box-type">
                                            <h6 className="filter_box_heading">SubCategory</h6>
                                            <div className="ShowPartsList-container-for-brand ">

                                                {
                                                    mainAndSubCategory != null ?

                                                        modelArrayAfterSelectingModel.length == 0 ?
                                                            <div className="m-2">
                                                                No sub category to show
                                                            </div> :
                                                            mainAndSubCategory.filter((itemOfFilter) => itemOfFilter.is_selected)[0]?.options?.filter((item) => item.is_selected).map((item) => {
                                                                return (
                                                                    <div className="PartsInACarModel-full-container-for-brand-element" onClick={() => clickedOnSubCategory(item.group)}>
                                                                        <img className="PartsInACarModel-full-container-for-brand-checkbox me-1" src={item.is_selected ? selected_checkbox : normal_checkbox} />
                                                                        <label className="PartsInACarModel-full-container-for-brand-name">{item.group}</label>
                                                                    </div>
                                                                )
                                                            })
                                                        :
                                                        null
                                                }
                                            </div>

                                            <button className="m-2 d-block btn btn-secondary btn-sm ms-auto" onClick={() => clickedOnSelectOptionPopup("subcategory")}>select</button>
                                        </div>

                                    </div>




                                </div>

                            }

                            <div className="ShowPartsList-right-part-container ">

                                {
                                    itemList ?
                                        <div className="Subcategory_main_container">

                                            <div className="d-flex flex-column parts-list-count-panel">

                                                <div className="ShowPartslist_result_and_continue_panel" >
                                                    <label className="search_result-in-parts-list"> {itemList?.length} results found </label>
                                                    {
                                                        itemList?.length != 0 &&
                                                        <label className="continue_button-in-parts-list" onClick={() => clickedOnMakeModelContinue()}>continue <img className="continue_arrow" src={ic_continue} /> </label>
                                                    }
                                                </div>

                                                {/* <div>
                                                searched text is {subSearchKey}
                                            </div> */}

                                            </div>



                                            <div className="Partlist_list_holding_container">


                                                {
                                                    data != null ?
                                                        data.map((item, index) => {
                                                            return (
                                                                <>
                                                                    <>
                                                                        {
                                                                            (item.isThisTitle) &&

                                                                            <div className="Grid-item-header Partlist_single_title">




                                                                                <div className="ShowParts_heading_ribbon_container_outer">
                                                                                    <div className="ShowParts_list_heading_ribbon_container">
                                                                                        <h4>
                                                                                            {`${item.isThisTitle}`}
                                                                                        </h4>
                                                                                    </div>
                                                                                </div>



                                                                            </div>
                                                                        }
                                                                    </>
                                                                    <>
                                                                        <div className="ShowPartsList-list-container-desktop-version">
                                                                            <div className="Partlist_single_row" key={index} >

                                                                                <div className="d-flex justify-content-between partlist_code_header_panel">

                                                                                    <label className="partlist_code">
                                                                                        {
                                                                                            item.Code
                                                                                        }
                                                                                    </label>

                                                                                    <label className="partlist_price">AED {item.price}</label>
                                                                                </div>

                                                                                <div className="d-flex justify-content-between align-items-baseline Partlist_card_total_container">

                                                                                    <span className="d-flex Partlist_image_header_column">


                                                                                        <img className="PartList-item-image me-2" onError={(e) => {
                                                                                            e.target.src = ic_no_image;
                                                                                        }} src={`http://autoland1.fortiddns.com:83/${item.imgPath}`} />

                                                                                        {/* <img src={ic_zoom} className="Partslist-zoom-icon" /> */}

                                                                                        <div className="d-flex justify-content-end">

                                                                                            <button className="btn-dark btn-sm ms-2" style={{ backgroundColor: "#265b8c", borderWidth: "0px" }} onClick={() => clickdeOnPartIcon(`http://autoland1.fortiddns.com:83/${item.imgPath}`, item)}> View Details &gt;</button>
                                                                                        </div>


                                                                                        <div className="ShowpartsList-hide-in-mobile">

                                                                                            <label className="PartList-item-name p-1">
                                                                                                <span className="PartsList-labelText me-2">DESCRIPTION</span>
                                                                                                {
                                                                                                    item.Description
                                                                                                }
                                                                                            </label>
                                                                                        </div>

                                                                                        <div className="ShowpartsList-hide-in-mobile">

                                                                                            <label className="PartList-item-name p-1">
                                                                                                <span className="PartsList-labelText me-2">BRAND</span>
                                                                                                {
                                                                                                    item.brand
                                                                                                }
                                                                                            </label>
                                                                                        </div>
                                                                                        {/* <div className="ShowpartsList-hide-in-mobile" >

                                                                                        <label className="PartList-item-name p-1">
                                                                                            <span className="PartsList-labelText me-2">GROUP</span>
                                                                                            {
                                                                                                item.Group
                                                                                            }
                                                                                        </label>
                                                                                    </div> */}

                                                                                        {/* <div className="ShowpartsList-hide-in-mobile">

                                                                                        <label className="PartList-item-name p-1">
                                                                                            <span className="PartsList-labelText me-2">WEIGHT</span>
                                                                                            {
                                                                                                item.Weight != null ? item.Weight : "--"
                                                                                            }
                                                                                        </label>
                                                                                    </div> */}
                                                                                        {/* <div className="ShowpartsList-hide-in-mobile" >

                                                                                        <label className="PartList-item-name p-1">
                                                                                            <span className="PartsList-labelText me-2">VOLUME</span>
                                                                                            {
                                                                                                item.Volume != null ? item.Volume : "--"
                                                                                            }
                                                                                        </label>
                                                                                    </div> */}
                                                                                    </span>

                                                                                    <span className="d-none d-sm-block  PartList-add-to-cart-span p-1 ShowpartsList-hide-in-mobile">
                                                                                        <span className="PartsList_quantity_input_span_container">
                                                                                            <img src={ic_minus} onClick={() => clickedOnInputQuantityChanger("decrement", item.quantity_in_shopping_cart, -1, item.Code)} />
                                                                                            <input
                                                                                                onScroll={(e) => scrollMouseWheelHappening(e)}
                                                                                                onWheel={(e) => preventMouseWheelHappening(e)}
                                                                                                className="PartsList_input_quantity_parts"
                                                                                                type="number" min="1" value={item.quantity_in_shopping_cart}
                                                                                                onChange={(e) => clickedOnInputQuantityChanger("input", item.quantity_in_shopping_cart, e, item.Code)} />
                                                                                            <img src={ic_plus} onClick={() => clickedOnInputQuantityChanger("increment", item.quantity_in_shopping_cart, 1, item.Code)} />
                                                                                        </span>
                                                                                        <button className="partlist_add_to_cart_button ms-2" onClick={() => { clickedOnShoppingCart(item); setCurrentItemAddedToCart(item) }}>Add to cart</button>
                                                                                    </span>

                                                                                </div>

                                                                                {/* <span className="d-block d-sm-none ms-auto  PartList-add-to-cart-span mt-2 p-1 ShowpartsList-hide-in-mobile">
                                                                            <span className="PartsList_quantity_input_span_container">
                                                                                <img src={ic_minus} onClick={() => clickedOnInputQuantityChanger("decrement", -1, item.Code)} />
                                                                                <input className="PartsList_input_quantity_parts" type="number" min="1" value={item.quantity_in_shopping_cart} onChange={(e) => clickedOnInputQuantityChanger("input", e, item.Code)} />
                                                                                <img src={ic_plus} onClick={() => clickedOnInputQuantityChanger("increment", 1, item.Code)} />
                                                                            </span>
                                                                            <button className="partlist_add_to_cart_button ms-2" onClick={() => { clickedOnShoppingCart(item); setCurrentItemAddedToCart(item) }}>Add to cart</button>
                                                                        </span> */}
                                                                            </div>
                                                                        </div>
                                                                        <div className="ShowPartsList-list-container-mobile-version">
                                                                            <div className="Partlist_single_row" key={index} onClick={() => clickdeOnPartIcon(`http://autoland1.fortiddns.com:83/${item.imgPath}`, item)}>



                                                                                {/* <div className="d-flex justify-content-between partlist_code_header_panel">

                                                                            <label className="partlist_code">
                                                                                {
                                                                                    item.Code
                                                                                }
                                                                            </label>

                                                                            <label className="partlist_price">AED {item.price}</label>
                                                                        </div> */}

                                                                                <div className="d-flex justify-content-between align-items-baseline Partlist_card_total_container">

                                                                                    <span className="d-flex Partlist_image_header_column">


                                                                                        <img className="PartList-item-image me-2" onError={(e) => {
                                                                                            e.target.src = ic_no_image;
                                                                                        }} src={`http://autoland1.fortiddns.com:83/${item.imgPath}`} />

                                                                                        {/* <img src={ic_zoom} className="Partslist-zoom-icon" /> */}

                                                                                        <div>

                                                                                            <div className="partlist_code">
                                                                                                {
                                                                                                    item.Code
                                                                                                }
                                                                                            </div>
                                                                                            <div className="PartList-item-name">

                                                                                                {
                                                                                                    item.Description
                                                                                                }
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* <div className="ShowpartsList-hide-in-mobile">

                                                                                    <label className="PartList-item-name p-1">
                                                                                        <span className="PartsList-labelText me-2">DESCRIPTION</span>
                                                                                        {
                                                                                            item.Description
                                                                                        }
                                                                                    </label>
                                                                                </div> */}

                                                                                        <div >
                                                                                            <label className="partlist_price">AED {item.price}</label>
                                                                                        </div>

                                                                                        {/* <div className="ShowpartsList-hide-in-mobile">

                                                                                    <label className="PartList-item-name p-1">
                                                                                        <span className="PartsList-labelText me-2">BRAND</span>
                                                                                        {
                                                                                            item.brand
                                                                                        }
                                                                                    </label>
                                                                                </div> */}
                                                                                        {/* <div className="ShowpartsList-hide-in-mobile" >

                                                                                    <label className="PartList-item-name p-1">
                                                                                        <span className="PartsList-labelText me-2">GROUP</span>
                                                                                        {
                                                                                            item.Group
                                                                                        }
                                                                                    </label>
                                                                                </div> */}

                                                                                        {/* <div className="ShowpartsList-hide-in-mobile">

                                                                                    <label className="PartList-item-name p-1">
                                                                                        <span className="PartsList-labelText me-2">WEIGHT</span>
                                                                                        {
                                                                                            item.Weight != null ? item.Weight : "--"
                                                                                        }
                                                                                    </label>
                                                                                </div> */}
                                                                                        {/* <div className="ShowpartsList-hide-in-mobile" >

                                                                                    <label className="PartList-item-name p-1">
                                                                                        <span className="PartsList-labelText me-2">VOLUME</span>
                                                                                        {
                                                                                            item.Volume != null ? item.Volume : "--"
                                                                                        }
                                                                                    </label>
                                                                                </div> */}
                                                                                    </span>

                                                                                    {/* <span className="d-none d-sm-block  PartList-add-to-cart-span p-1 ShowpartsList-hide-in-mobile">
                                                                                <span className="PartsList_quantity_input_span_container">
                                                                                    <img src={ic_minus} onClick={() => clickedOnInputQuantityChanger("decrement", -1, item.Code)} />
                                                                                    <input className="PartsList_input_quantity_parts" type="number" min="1" value={item.quantity_in_shopping_cart} onChange={(e) => clickedOnInputQuantityChanger("input", e, item.Code)} />
                                                                                    <img src={ic_plus} onClick={() => clickedOnInputQuantityChanger("increment", 1, item.Code)} />
                                                                                </span>
                                                                                <button className="partlist_add_to_cart_button ms-2" onClick={() => { clickedOnShoppingCart(item); setCurrentItemAddedToCart(item) }}>Add to cart</button>
                                                                            </span> */}

                                                                                </div>

                                                                                {/* <span className="d-block d-sm-none ms-auto  PartList-add-to-cart-span mt-2 p-1 ShowpartsList-hide-in-mobile">
                                                                            <span className="PartsList_quantity_input_span_container">
                                                                                <img src={ic_minus} onClick={() => clickedOnInputQuantityChanger("decrement", -1, item.Code)} />
                                                                                <input className="PartsList_input_quantity_parts" type="number" min="1" value={item.quantity_in_shopping_cart} onChange={(e) => clickedOnInputQuantityChanger("input", e, item.Code)} />
                                                                                <img src={ic_plus} onClick={() => clickedOnInputQuantityChanger("increment", 1, item.Code)} />
                                                                            </span>
                                                                            <button className="partlist_add_to_cart_button ms-2" onClick={() => { clickedOnShoppingCart(item); setCurrentItemAddedToCart(item) }}>Add to cart</button>
                                                                        </span> */}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                </>


                                                            )
                                                        })
                                                        :
                                                        null
                                                }

                                            </div>

                                            {hasMore && (
                                                <div ref={targetRef} className="load_more_container">

                                                    <div className="spinner-border" role="status">

                                                    </div>
                                                    <span className="sr-only ms-2">Loading more items...</span>
                                                </div>
                                            )}

                                        </div>
                                        :
                                        <div className="Subcategory_main_container">
                                            <div className="d-flex justify-content-center align-items-center">
                                                <p style={{fontSize:"18px", padding:"20px"}}>No items found</p>
                                            </div>
                                        </div>
                                }



                            </div>

                        </div>
                    </div>


            }

            {
                showCartSidebar &&
                <CartSidebar setShowCartSidebar={setShowCartSidebar} currentItemAddedToCart={currentItemAddedToCart} />
            }

            {
                clickedImagelink != null &&

                <div className="popup-outer">
                    <div className="Showparts_list_popup-inner">

                        <div className="Showpartslist_detail_popup">
                            <div className="left">
                                <span className="d-flex justify-content-end control-panel-for-zoom">
                                    <span className="d-flex justify-content-center align-items-center w-100">
                                        <div className="zoomOptionButtonContainer">
                                            <button onClick={() => zoomInTheImage(0.5)}><img src={ic_zoomin} /></button>
                                            <button onClick={() => zoomOutTheImage(0.5)}><img src={ic_zoomout} /></button>
                                            <button onClick={() => resetTheImage(1)}><img src={ic_zoom_reset} /></button>
                                        </div>
                                    </span>

                                </span>

                                <div className="ShowPartsList_zooming_container">
                                    <img ref={imageToBeZoomedRef} className="imageToBeZoomed" src={clickedImagelink} alt="" />
                                </div>
                            </div>
                            <div className="right">

                                <div className="d-flex justify-content-end Showpartslist_popup_close_button_mobile">
                                    <button className="m-1 btn btn-sm btn-dark d-flex align-items-center" style={{ backgroundColor: "#e44444", borderWidth: "0px" }} onClick={() => setClickedImageLink(null)}><img className="ShowPartsList_close_img_popup" src={ic_close_popup} />Close</button>
                                </div>


                                <table className="ShowPartlist_table">
                                    <tbody>
                                        <tr>
                                            <th className="pe-4 ShowPartlist_table_label">Code</th>
                                            <th className="ShowPartlist_table_value">{clickedItemToShowInPopup.Code}</th>
                                        </tr>
                                        <tr>
                                            <th className="pe-4 ShowPartlist_table_label">Description</th>
                                            <th className="ShowPartlist_table_value">{clickedItemToShowInPopup.Description}</th>
                                        </tr>
                                        <tr>
                                            <th className="pe-4 ShowPartlist_table_label">Brand</th>
                                            <th className="ShowPartlist_table_value">{clickedItemToShowInPopup.brand}</th>
                                        </tr>
                                        <tr>
                                            <th className="pe-4 ShowPartlist_table_label">Group</th>
                                            <th className="ShowPartlist_table_value">{clickedItemToShowInPopup.Group}</th>
                                        </tr>
                                        <tr>
                                            <th className="pe-4 ShowPartlist_table_label">Weight</th>
                                            <th className="ShowPartlist_table_value">{clickedItemToShowInPopup.Weight}</th>
                                        </tr>
                                        <tr>
                                            <th className="pe-4 ShowPartlist_table_label">Volume</th>
                                            <th className="ShowPartlist_table_value">{clickedItemToShowInPopup.Volume}</th>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className="ShowParts_heading_ribbon_container_outer mt-2">
                                    <div className=" ShowParts_list_heading_ribbon_container_popup" >

                                        <label className="partlist_price_in_popup p-1">
                                            AED {clickedItemToShowInPopup.price}
                                        </label>
                                    </div>
                                </div>

                                <div className="ms-auto  PartList-add-to-cart-span mt-4 p-1">
                                    <span className="PartsList_quantity_input_span_container">
                                        <img src={ic_minus} onClick={() => clickedOnInputQuantityChanger("decrement", clickedItemToShowInPopup.quantity_in_shopping_cart, -1, clickedItemToShowInPopup.Code)} />
                                        <input
                                            onWheel={(e) => preventMouseWheelHappening(e)}
                                            className="PartsList_input_quantity_parts"
                                            type="number" min="1"
                                            value={clickedItemToShowInPopup.quantity_in_shopping_cart}
                                            onChange={(e) => clickedOnInputQuantityChanger("input", clickedItemToShowInPopup.quantity_in_shopping_cart, e, clickedItemToShowInPopup.Code)} />
                                        <img src={ic_plus} onClick={() => clickedOnInputQuantityChanger("increment", clickedItemToShowInPopup.quantity_in_shopping_cart, 1, clickedItemToShowInPopup.Code)} />
                                    </span>
                                    <button className="partlist_add_to_cart_button ms-2" onClick={() => { clickedOnShoppingCart(clickedItemToShowInPopup); setCurrentItemAddedToCart(clickedItemToShowInPopup) }}>Add to cart</button>
                                </div>


                            </div>
                        </div>

                    </div>
                </div>
            }
            {
                showOptionPopup &&
                <div className="popup-outer ShowPartsList-option-popup">
                    <div className="ShowpartsList-options-inner-container">
                        <div className="Showpartslist-option-popup-head d-flex align-items-center justify-content-between py-2 px-2 mb-4">
                            <h6 className="m-0">Select {currentSelectedOption.current}</h6>
                            <span>
                                <button className="btn btn-sm ms-4" style={{ backgroundColor: "#f7f7f7" }} onClick={() => setShowOptionPopup(prev => !prev)}>Cancel</button>
                                <button className="btn btn-danger btn-sm ms-1" onClick={() => clickedOnSelectOptionPopup("")}>Apply</button>
                            </span>
                        </div>
                        <div className="px-2 pb-4">

                            <div>
                                <input
                                    onChange={(e) => handleListSearchInput(e)}
                                    type="text" style={{
                                        border: "none",
                                        backgroundColor: "#e5e5e5",
                                        outline: "none", color: "#000000", padding: "6px", minnWidt: "250px"
                                    }} placeholder="Search" />
                            </div>
                            {
                                getArrayOfOption(currentSelectedOption.current, userSearchedTextState, getKeyOfOption(currentSelectedOption.current))?.map((itemReceived, index) => {
                                    return (
                                        <div className="PartsInACarModel-full-container-for-brand-element option-popup-list-single-item" onClick={() => callMethod(
                                            currentSelectedOption.current,
                                            itemReceived[getKeyOfOption(currentSelectedOption.current)]

                                        )}
                                            key={itemReceived[getKeyOfOption(currentSelectedOption.current)]}>
                                            <img className="PartsInACarModel-full-container-for-brand-checkbox me-1" src={itemReceived.is_selected ? selected_checkbox : normal_checkbox} />
                                            <label className="PartsInACarModel-full-container-for-brand-name">{itemReceived[getKeyOfOption(currentSelectedOption.current)]}</label>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            }


        </div>
    )
}

export default ShowPartsList;